import YFormSeo from './Seo';

export { YFormSeo };
export default YFormSeo;
